export enum ProductType
{
  ProductCheck = "Cheque",
  ProductCriptoUpload  = "USDT Subida",
  ProductCriptoDownload  = "USDT Bajada",
  ProductWireUpload  = "Transferencia Subida",
  ProductWireDownload  = "Transferencia Bajada",
  ProductExchange = "Cambio"
}

export enum ProductAPIType
{
  ProductCheck = "Cheque",
  ProductCripto  = "USDT",
  ProductWire  = "Transferencia",
  ProductExchange = "Cambio",
}

export enum ProductCurrency
{
    Pesos = "ARS",
    Dolar = "USD",
    Real = "BRL",
    Euro = "EUR",
}

export enum ProductState
{
    Pending  = "Pendiente",
    Checked = "Ingresada a cuenta",
    OnSystem = "Pasado al sistema",
    ReadyToExecute = "Listo para ejecutar",
    Done = "Ingresada a cuenta y pasado al sistema",
    Cancel = "Cancelado"
}

export enum ProductAuditState
{
    Pending  = "Creado",
    Created  = "Creado",
    Create  = "Creado",
    Edit  = "Editado",
    Edited  = "Editado",
    Checked = "Ingresada a cuenta",
    OnSystem = "Pasado al sistema",
    ReadyToExecute = "Listo para ejecutar",
    Done = "Finalizado"
}

export enum ProductStateProvince {
  CABA = "Camara",
  BUENOS_AIRES = "Interior"
}
